import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSynologyComponent } from './simple-icons-synology.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSynologyComponent ],
    exports:      [ SimpleIconsSynologyComponent ],
    bootstrap:    []
})
export class SimpleIconsSynologyModule {}
